// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

:host-context(.mc-dark) ::ng-deep .tox.tox-tinymce {
  border-color: var(--mc-border-strong);
  box-shadow: none;
}
:host-context(.mc-dark) ::ng-deep .tox .tox-edit-area__iframe {
  background: #121212;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/rich-text-editor/rich-text-editor.component.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;;AAGC;EACC,qCAAA;EACA,gBAAA;AAAF;AAGC;EACC,mBAAA;AADF","sourcesContent":[":host {\r\n\tdisplay: block;\r\n}\r\n\r\n:host-context(.mc-dark) {\r\n\t::ng-deep .tox.tox-tinymce {\r\n\t\tborder-color: var(--mc-border-strong);\r\n\t\tbox-shadow: none;\r\n\t}\r\n\r\n\t::ng-deep .tox .tox-edit-area__iframe {\r\n\t\tbackground: #121212;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
